import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW4001Model } from '../kymw4001.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * プロモーションマスタ一覧画面　週次プロモーションマスタ一覧を取得するサービス
 *
 * @export GetPromotionListService
 * @class GetPromotionListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetPromotionListService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW4001Model}
   * @memberof GetPromotionListService
   */
  private model: KYMW4001Model;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetPromotionListService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetPromotionListService
   */
  execute(model: any, successFunc: Function): void {
    this.model = <KYMW4001Model> model;
    this.successFunc = successFunc; 
    this.send('KYMW40getPromotionList', new PlessRequest()); 
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPromotionListService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }

}
